<div class="content-wrapper">
    <div class="content-wrapper">
        <div class="content-body">

            <app-content-header [contentHeader]="contentHeader"></app-content-header>

            <div class="alert alert-danger p-1" *ngIf="erro">
                {{erro}}
            </div>

            <div class="card">
                <div class="card-body pb-0">
                    <ul ngbNav class="nav-tabs" [activeId]="sistema">
                        <li [ngbNavItem]="2">
                            <a ngbNavLink (click)="trocarSistema(2)">Rastreei</a>
                        </li>
                        <li [ngbNavItem]="3">
                            <a ngbNavLink (click)="trocarSistema(3)">FaleFlex</a>
                        </li>
                    </ul>

                    <div class="d-flex flex-wrap justify-content-between align-items-center mb-1">
                        <div>
                            <h4 class="mb-0">Fechamento {{idFechamento}}</h4>
                            <small class="text-muted" *ngIf="vigencia">Vigência {{vigencia}} · vendas do fechamento (inclusive
                                canceladas) e clientes habilitados para gerar boleto</small>
                        </div>
                        <div>
                            <button class="btn btn-outline-primary btn-sm mr-1" routerLink="/fechamento">
                                <i data-feather="arrow-left" class="mr-25"></i> Voltar
                            </button>
                            <button class="btn btn-primary btn-sm" (click)="atualizarTodos()"
                                [disabled]="atualizandoTodos || carregando || indicadores.gerados == 0"
                                title="Consulta no Efí o status das vendas não canceladas desta aba e atualiza o Gestão Click">
                                <span *ngIf="atualizandoTodos" class="spinner-border spinner-border-sm mr-50"></span>
                                <span *ngIf="!atualizandoTodos"><i data-feather="refresh-cw" class="mr-25"></i></span>
                                Atualizar status no Efí
                            </button>
                        </div>
                    </div>

                    <!-- INDICADORES (clique filtra a tabela) -->
                    <div class="row">
                        <div class="col-6 col-md-4 col-xl-2 mb-1">
                            <div class="card border mb-0 h-100 indicador" [class.border-primary]="filtroIndicador == ''"
                                (click)="filtrarIndicador('')">
                                <div class="card-body p-1">
                                    <p class="text-muted mb-25">Habilitados</p>
                                    <h3 class="font-weight-bolder mb-0">{{indicadores.habilitados}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-4 col-xl-2 mb-1">
                            <div class="card border mb-0 h-100 indicador" [class.border-primary]="filtroIndicador == 'gerados'"
                                (click)="filtrarIndicador('gerados')">
                                <div class="card-body p-1">
                                    <p class="text-muted mb-25">Gerados</p>
                                    <h3 class="font-weight-bolder mb-0">{{indicadores.gerados}}</h3>
                                    <small *ngIf="indicadores.canceladas > 0" class="link-canceladas"
                                        [class.font-weight-bolder]="filtroIndicador == 'canceladas'"
                                        (click)="$event.stopPropagation(); filtrarIndicador('canceladas')">
                                        + {{indicadores.canceladas}} cancelada(s)
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-4 col-xl-2 mb-1">
                            <div class="card border mb-0 h-100 indicador"
                                [class.border-primary]="filtroIndicador == 'naoGerados'" (click)="filtrarIndicador('naoGerados')">
                                <div class="card-body p-1">
                                    <p class="text-muted mb-25">Não gerados</p>
                                    <h3 class="font-weight-bolder mb-0"
                                        [class.text-warning]="indicadores.naoGerados > 0">{{indicadores.naoGerados}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-4 col-xl-2 mb-1">
                            <div class="card border mb-0 h-100 indicador" [class.border-primary]="filtroIndicador == 'pagos'"
                                (click)="filtrarIndicador('pagos')">
                                <div class="card-body p-1">
                                    <p class="text-muted mb-25">Pagos</p>
                                    <h3 class="font-weight-bolder mb-0 text-success">{{indicadores.pagos}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-4 col-xl-2 mb-1">
                            <div class="card border mb-0 h-100 indicador"
                                [class.border-primary]="filtroIndicador == 'pendencias'" (click)="filtrarIndicador('pendencias')">
                                <div class="card-body p-1">
                                    <p class="text-muted mb-25">Com pendência</p>
                                    <h3 class="font-weight-bolder mb-0"
                                        [class.text-danger]="indicadores.pendencias > 0">{{indicadores.pendencias}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-4 col-xl-2 mb-1">
                            <div class="card border mb-0 h-100">
                                <div class="card-body p-1">
                                    <p class="text-muted mb-25">Sem cobrança</p>
                                    <h3 class="font-weight-bolder mb-0 text-muted">{{semCobranca.length}}</h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- FILTROS -->
                    <div class="row">
                        <div class="col-md-5 mb-1">
                            <input type="search" class="form-control" placeholder="Buscar por cliente ou CNPJ"
                                [(ngModel)]="filtroTexto" (keyup)="aplicarFiltros()" (search)="aplicarFiltros()" />
                        </div>
                        <div class="col-md-4 mb-1">
                            <select class="form-control" [(ngModel)]="filtroStatus" (change)="aplicarFiltros()">
                                <option value="">Todos os status</option>
                                <option *ngFor="let s of statusDisponiveis" [value]="s">{{s}}</option>
                            </select>
                        </div>
                        <div class="col-md-3 mb-1 d-flex">
                            <button class="btn btn-outline-secondary flex-fill mr-50" (click)="limparFiltros()">Limpar</button>
                            <button class="btn btn-outline-primary flex-fill" (click)="carregar()" [disabled]="carregando"
                                title="Refaz a consulta das vendas deste fechamento, mantendo os filtros (não consulta o Efí)">
                                <span *ngIf="carregando" class="spinner-border spinner-border-sm mr-25"></span>
                                <span *ngIf="!carregando"><i data-feather="rotate-cw" class="mr-25"></i></span>
                                Recarregar
                            </button>
                        </div>
                    </div>
                </div>

                <section>
                    <ngx-datatable class="material core-bootstrap" [rows]="rows" [rowHeight]="'auto'" [limit]="15"
                        columnMode="force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true"
                        [loadingIndicator]="carregando" [reorderable]="false" style="box-shadow: none">

                        <!-- ETAPAS (linha expandida) -->
                        <ngx-datatable-row-detail [rowHeight]="'auto'">
                            <ng-template let-row="row" ngx-datatable-row-detail-template>
                                <div class="px-2 py-1 bg-light-secondary">
                                    <p class="text-muted mb-50" *ngIf="!row.controlada">
                                        Venda criada antes do controle de etapas: só o que foi identificado aparece como concluído.
                                    </p>
                                    <p class="text-muted mb-50" *ngIf="row.statusLabel == 'Status não confirmado'">
                                        O Efí ainda não confirmou o boleto desta venda. Use "Atualizar status no Efí" para consultar.
                                    </p>
                                    <div class="linha-etapa" *ngFor="let etapa of row.etapas">
                                        <div class="avatar avatar-sm mr-75" [ngClass]="{
                                            'bg-light-success': etapa.status == 'ok',
                                            'bg-light-danger': etapa.status == 'erro',
                                            'etapa-pendente': etapa.status == 'pendente' || etapa.status == 'sem_registro'}">
                                            <div class="avatar-content">
                                                <span *ngIf="etapa.status == 'ok'"><i data-feather="check" class="avatar-icon"></i></span>
                                                <span *ngIf="etapa.status == 'erro'"><i data-feather="x" class="avatar-icon"></i></span>
                                                <span *ngIf="etapa.status == 'sem_registro'"><i data-feather="minus" class="avatar-icon text-muted"></i></span>
                                            </div>
                                        </div>
                                        <span class="nome-etapa font-weight-bold">{{etapa.nome}}</span>
                                        <span *ngIf="etapa.status == 'ok'" class="text-muted">
                                            {{etapa.data ? (etapa.data | date:'dd/MM/yyyy HH:mm') : 'concluída'}}
                                        </span>
                                        <span *ngIf="etapa.status == 'erro'" class="text-danger">
                                            {{etapa.mensagem}}<span *ngIf="etapa.data" class="text-muted"> · {{etapa.data | date:'dd/MM/yyyy HH:mm'}}</span>
                                        </span>
                                        <span *ngIf="etapa.status == 'pendente'" class="text-muted">não executada</span>
                                        <span *ngIf="etapa.status == 'sem_registro'" class="text-muted">sem registro</span>
                                        <span *ngIf="etapa.nome == 'E-mail' && row.qtd_email_enviado > 0" class="text-muted ml-50">
                                            ({{row.qtd_email_enviado}} envio(s))
                                        </span>
                                        <ng-container [ngSwitch]="acaoEtapa(row, etapa)">
                                            <button *ngSwitchCase="'gestao_click'" class="btn btn-sm btn-outline-primary ml-1 text-nowrap"
                                                [disabled]="reenviando[row.id_venda]" (click)="reenviarGestaoClick(row)">
                                                <span *ngIf="reenviando[row.id_venda]" class="spinner-border spinner-border-sm mr-25"></span>
                                                Reenviar ao Gestão Click
                                            </button>
                                            <button *ngSwitchCase="'email'" class="btn btn-sm btn-outline-primary ml-1 text-nowrap"
                                                [disabled]="compartilhando[row.id_venda] || !podeCompartilhar(row)" (click)="compartilharEmail(row)">
                                                <span *ngIf="compartilhando[row.id_venda]" class="spinner-border spinner-border-sm mr-25"></span>
                                                Reenviar e-mail
                                            </button>
                                            <small *ngSwitchCase="'crawler'" class="text-muted ml-1">
                                                o crawler refaz:
                                                <code>crawler_fechamento.py -s prod --id-sistema {{sistema}} --id-cliente {{row.id_cliente}}</code>
                                            </small>
                                            <small *ngSwitchCase="'boleto'" class="text-muted ml-1">
                                                refazer pela tela criaria outra cobrança: cancele a venda no Efí e gere de novo
                                            </small>
                                            <small *ngSwitchCase="'gestao_click_rastreei'" class="text-muted ml-1">
                                                reenvio pela tela disponível só para FaleFlex
                                            </small>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-template>
                        </ngx-datatable-row-detail>

                        <ngx-datatable-column name="CNPJ" prop="cpf_cnpj" [sortable]="false" [width]="150">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="text-nowrap">{{row.cpf_cnpj}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="false" [width]="250">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="font-weight-bold">{{row.cliente}}</span>
                                <span class="badge badge-pill badge-light-warning ml-50" *ngIf="row.id_status_cliente == 4">Bloqueado</span>
                                <span class="badge badge-pill badge-light-danger ml-50" *ngIf="row.qtd_vendas_ativas > 1"
                                    ngbTooltip="Há {{row.qtd_vendas_ativas}} vendas ativas deste cliente neste fechamento (cobrança em dobro). Cancele no Efí as que sobram."
                                    container="body">Venda duplicada</span>
                                <div *ngIf="row.gerado">
                                    <small class="text-muted">venda {{row.id_venda}}<span *ngIf="row.charge_id"> · cobrança
                                            {{row.charge_id}}</span></small>
                                </div>
                                <div *ngIf="!row.gerado && row.venda_cancelada">
                                    <small class="text-muted">venda {{row.venda_cancelada}} cancelada</small>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Valor" prop="valor_total" [sortable]="false" [width]="120">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span *ngIf="row.valor_total != null" class="text-nowrap">{{row.valor_total | currency:'BRL':'symbol':'1.2-2':'pt'}}</span>
                                <span *ngIf="row.valor_total == null" class="text-muted">-</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Status" prop="statusLabel" [sortable]="false" [width]="170">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="badge badge-pill badge-light-{{row.statusCor}}">{{row.statusLabel}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Dt. Vencimento" prop="data_vencimento" [sortable]="false" [width]="120">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span *ngIf="row.data_vencimento">{{row.data_vencimento | date:'dd/MM/yyyy':'UTC'}}</span>
                                <span *ngIf="!row.data_vencimento" class="text-muted">-</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Etapas" [sortable]="false" [width]="190">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <div class="d-flex align-items-center" *ngIf="row.gerado" (click)="alternarEtapas(row)">
                                    <div *ngFor="let etapa of row.etapas" class="avatar avatar-sm etapa" [ngClass]="{
                                        'bg-light-success': etapa.status == 'ok',
                                        'bg-light-danger': etapa.status == 'erro',
                                        'etapa-pendente': etapa.status == 'pendente' || etapa.status == 'sem_registro'}"
                                        [ngbTooltip]="dicaEtapa(etapa)" container="body" placement="top">
                                        <div class="avatar-content">
                                            <span *ngIf="etapa.status == 'ok'"><i data-feather="check" class="avatar-icon"></i></span>
                                            <span *ngIf="etapa.status == 'erro'"><i data-feather="x" class="avatar-icon"></i></span>
                                            <span *ngIf="etapa.status == 'sem_registro'"><i data-feather="minus" class="avatar-icon text-muted"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <span *ngIf="!row.gerado" class="text-muted">-</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Ações" [sortable]="false" [width]="110">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <div class="d-flex align-items-center justify-content-end">
                                    <ng-container *ngIf="row.gerado">
                                        <a href="javascript:void(0);" class="mr-75" ngbTooltip="Atualizar status no Efí" container="body"
                                            (click)="atualizarStatus(row)">
                                            <span *ngIf="atualizando[row.id_venda]" class="spinner-border spinner-border-sm text-primary"></span>
                                            <span *ngIf="!atualizando[row.id_venda]"><i data-feather="refresh-cw" class="text-primary"></i></span>
                                        </a>
                                        <div ngbDropdown container="body" *ngIf="!row.cancelada">
                                            <a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow" ngbTooltip="Compartilhar"
                                                container="body">
                                                <span *ngIf="compartilhando[row.id_venda]" class="spinner-border spinner-border-sm text-primary"></span>
                                                <span *ngIf="!compartilhando[row.id_venda]"><i data-feather="share-2" class="text-primary"></i></span>
                                            </a>
                                            <div ngbDropdownMenu class="dropdown-menu-right">
                                                <button ngbDropdownItem [disabled]="!podeCompartilhar(row)" (click)="compartilharEmail(row)">
                                                    <i data-feather="mail" class="mr-50"></i> Compartilhar boleto por e-mail
                                                </button>
                                                <button ngbDropdownItem [disabled]="!podeCompartilhar(row)" (click)="compartilharWhatsapp(row)">
                                                    <i data-feather="message-circle" class="mr-50"></i> Compartilhar boleto por WhatsApp
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <a *ngIf="!row.gerado" [routerLink]="['/fechamento', idFechamento, 'clientes', row.id_cliente]"
                                        ngbTooltip="Abrir o detalhamento para gerar a venda" container="body">
                                        <i data-feather="external-link" class="text-primary"></i>
                                    </a>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>

                    <div class="p-2" *ngIf="!carregando && !erro && rows.length == 0">
                        <p class="text-center text-muted mb-0">Nenhuma venda ou cliente encontrado com esses filtros.</p>
                    </div>
                </section>
            </div>

            <!-- SEM COBRANÇA -->
            <div class="card" *ngIf="semCobranca.length > 0">
                <div class="card-body">
                    <h5 class="mb-50">Sem cobrança neste fechamento ({{semCobranca.length}})</h5>
                    <p class="text-muted">Clientes do fechamento que não geram boleto: o "Cobrar" do cadastro não está Ativo para o
                        que eles têm<span *ngIf="sistema == 3">, ou os serviços são diferentes do fechamento anterior (a
                            quantidade de itens mudou: o crawler não gera; acerte os itens do fechamento ou gere pelo Detalhamento, que pede
                            confirmação)</span>.</p>
                    <div *ngFor="let c of semCobranca" class="mb-50">
                        <span class="font-weight-bold">{{c.cliente}}</span>
                        <span class="badge badge-pill badge-light-warning ml-50" *ngIf="c.servicos_diferentes">Serviços diferentes</span>
                        <span class="text-muted"> · {{c.cpf_cnpj}} · {{c.motivo}}</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
